import Dictionary from "../../dictionary/dictionary";
import {PortService} from "../../../services/portService";
import {PortModel} from "../../../models/ports";
import i18n from "../../../../i18n/i18n";
import {NavLink} from "react-router-dom";
import {routingAddresses} from "../../../../helpers/routing";
import Button from "../../../../common/components/shared/button/button";
import {Api} from "../../../../helpers/api";
import ReloadButton from "../../../../common/components/shared/reloadButton/reloadButton";
import {CountryModel} from "../../../../common/models/country";
import {SortDirection} from "../../../../common/models/table";

export default class PortsList extends Dictionary<PortModel> {
    private sortableElements = ["name", "imoCode"];

    constructor(props: any) {
        super(props);
        this.canRemove = true;
        this.linkToModify = routingAddresses.dictionaries.ports.modify;
    }

    public async componentDidMount() {
        this.getData((await PortService.getAll({
            orderBy: this.state.orderBy,
            sortDirection: this.state.sortDirection
        })));
    }

    public render(): JSX.Element {
        const properties = ["name", "imoCode", "country"];
        const headers = properties.map(key => i18n.t("dictionaries.ports.headers." + key));

        const actions = this.renderActions;

        return (
            <div className="ports">
                {this.renderRemovePopup(this.confirmRemove.bind(this))}
                {this.renderWrapperContent(headers, properties, "ports", actions, this.renderCell, this.getHeader(), this.sortableElements, this.sortingAction.bind(this))}
            </div>
        );
    }

    private getHeader() {
        return (
            <div className="actions">
                <NavLink to={routingAddresses.dictionaries.ports.add} data-testid="add-port">
                    <Button type="primary" text={i18n.t("dictionaries.ports.actions.addPort.button")}/>
                </NavLink>
                <ReloadButton
                    reloadFunc={this.reload.bind(this)}
                    testId="port-list-reload-btn"
                />
            </div>
        );
    }

    private async reload() {
        this.reloadList((await PortService.getAll({
            orderBy: this.state.orderBy,
            sortDirection: this.state.sortDirection
        })));
    }

    private renderCell(row: any, property: string): JSX.Element {
        if (property === "country") {
            const country = row[property] as CountryModel;
            return <>{country.name}</>;
        }
        return row[property];
    }

    protected async confirmRemove() {
        this.setState({removeItemResponse: undefined, isWaiting: true});

        const response = await PortService.removePort(this.state.selectedElement!.id);

        this.setState({removeItemResponse: response});

        if (Api.isSuccess(response)) {
            await this.getData((await PortService.getAll({
                orderBy: this.state.orderBy,
                sortDirection: this.state.sortDirection
            })));
            this.setState({selectedElement: undefined, displayRemovePopup: false});
        } else {
            this.setState({errorMessage: i18n.t("dictionaries.ports.errors.removeErrorSuffix")});
        }
        this.setState({isWaiting: false});
    }

    private async sortingAction(orderBy: string, sortDirection: SortDirection) {
        await this.setState({orderBy, sortDirection});
        await this.reload();
    }
}


